'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicyEn = function (_React$Component) {
    _inherits(PrivacyPolicyEn, _React$Component);

    function PrivacyPolicyEn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PrivacyPolicyEn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivacyPolicyEn.__proto__ || Object.getPrototypeOf(PrivacyPolicyEn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            companyName: 'Beijing Xiaowei Cloud Inc.'
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PrivacyPolicyEn, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = 'DkNote - 개인 정보 보호 계약';
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            'DkNote'
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'eula' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'title' },
                        ' \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uACC4\uC57D '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\uC774 \uC57D\uAD00\uC740 2023\uB144 8\uC6D4 8\uC77C\uC5D0 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4. '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uC774 \uBB38\uC11C ( "DkNote \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uACC4\uC57D")\uB294 \uADC0\uD558\uAC00 \uB2F9\uC0AC\uC758 \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uBC0F \uC11C\uBE44\uC2A4\uC5D0 \uC561\uC138\uC2A4, \uC124\uCE58 \uB610\uB294 \uC0AC\uC6A9\uD560 \uB54C \uC218\uC9D1\uB418\uAC70\uB098 \uC81C\uCD9C \uB41C \uBAA8\uB4E0 \uC815\uBCF4\uC5D0 \uC801\uC6A9\uB418\uB294 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uACC4\uC57D\uC744 \uC124\uBA85\uD569\uB2C8\uB2E4. '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        ' \uC6F9 \uC0AC\uC774\uD2B8\uB97C \uBC29\uBB38\uD558\uC5EC \uAC1C\uC778 \uB370\uC774\uD130\uB97C \uC81C\uCD9C\uD558\uACE0 \uC11C\uBE44\uC2A4\uC5D0 \uC561\uC138\uC2A4, \uC124\uCE58 \uBC0F / \uB610\uB294 \uC0AC\uC6A9\uD568\uC73C\uB85C\uC368 \uADC0\uD558\uB294\uC774 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45\uC744 \uC77D\uC5C8\uC73C\uBA70 \uBCF8 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45\uC758 \uC870\uAC74\uC5D0 \uB3D9\uC758\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4. \uC774 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45\uC758 \uC870\uAC74\uC5D0 \uB3D9\uC758\uD558\uC9C0 \uC54A\uC73C\uBA74 \uC11C\uBE44\uC2A4 \uC0AC\uC6A9\uC744 \uC911\uC9C0\uD558\uC2ED\uC2DC\uC624. '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uB370\uC774\uD130 \uCC98\uB9AC '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uB2F9\uC0AC\uB294 \uC11C\uBE44\uC2A4 \uC81C\uACF5, \uC11C\uBE44\uC2A4 \uACB0\uC81C \uCC98\uB9AC, \uB2F9\uC0AC \uC6F9 \uC0AC\uC774\uD2B8 \uBC0F \uBAA8\uBC14\uC77C \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC758 \uAE30\uB2A5 \uB4F1 \uC81C\uD55C\uB41C \uBC94\uC704 \uB0B4\uC5D0\uC11C \uC0AC\uC6A9\uC790 \uB370\uC774\uD130\uB97C \uCC98\uB9AC\uD569\uB2C8\uB2E4. \uC6B0\uB9AC\uB294 \uB2E4\uC74C\uACFC \uAC19\uC740 \uAE30\uBCF8 \uC815\uBCF4\uB97C \uCC98\uB9AC\uD569\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uACC4\uC815 \uC0DD\uC131 \uC815\uBCF4 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uC774\uBA54\uC77C \uC8FC\uC18C : \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uACC4\uC815 \uC815\uBCF4\uB85C \uC0AC\uC6A9\uD558\uB294 \uACBD\uC6B0 \uB2F9\uC0AC\uB294\uC774\uB97C \uC0AC\uC6A9\uD558\uC5EC \uACC4\uC815\uC744 \uC0DD\uC131\uD558\uB294 \uB3D9\uC2DC\uC5D0 \uC78A\uC5B4 \uBC84\uB9B0 \uBE44\uBC00\uBC88\uD638\uB97C \uAC80\uC0C9\uD558\uB294 \uB370 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD604\uC7AC \uC774\uBA54\uC77C \uC8FC\uC18C\uAC00 \uBC18\uB4DC\uC2DC \uACC4\uC815\uC73C\uB85C \uD544\uC694\uD558\uC9C0\uB294 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uADC0\uD558\uC758 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uADC0\uD558\uC758 \uACC4\uC815\uC73C\uB85C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC73C\uBBC0\uB85C \uADC0\uD558\uC758 \uAC1C\uC778 \uC815\uBCF4\uB97C \uD5A5\uC0C1\uC2DC\uD0AC \uC218 \uC788\uC9C0\uB9CC\uC774 \uACBD\uC6B0 \uBD84\uC2E4 \uD55C \uC554\uD638\uB97C \uAC80\uC0C9\uD558\uB294 \uB370 \uB3C4\uC6C0\uC744 \uB4DC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC774 \uACBD\uC6B0 (\uBE44\uBC00\uBC88\uD638 \uBD84\uC2E4) \uD56D\uC0C1 \uD68C\uC6D0\uAD8C\uC744 \uC783\uAC8C\uB429\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uACB0\uC81C \uAD00\uB828 \uC815\uBCF4 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uACB0\uC81C \uB370\uC774\uD130 (\uC720\uB8CC \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD558\uB294 \uACBD\uC6B0) :\uC774 \uC815\uBCF4\uB294 \uC11C\uBE44\uC2A4 \uC694\uAE08\uC744 \uCCAD\uAD6C\uD558\uB294 \uB370 \uD544\uC694\uD569\uB2C8\uB2E4. \uB2F9\uC0AC\uC758 \uACB0\uC81C \uCC98\uB9AC \uD30C\uD2B8\uB108\uB294 \uACB0\uC81C \uCC98\uB9AC \uBC0F \uD658\uBD88 \uC694\uCCAD\uC744\uC704\uD55C \uAE30\uBCF8 \uACB0\uC81C \uC815\uBCF4 (\uC608 : \uAD6C\uB9E4 \uB0A0\uC9DC, \uC9C0\uBD88 \uC778\uC758 IP \uC8FC\uC18C, \uC6B0\uD3B8 \uBC88\uD638, \uC740\uD589 \uCE74\uB4DC \uC18C\uC720\uC790\uC758 \uC131\uBA85 \uBC0F \uC2E0\uC6A9 \uCE74\uB4DC \uC815\uBCF4)\uB97C \uCC98\uB9AC\uD569\uB2C8\uB2E4. \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uB294 \uACBD\uC6B0\uC5D0\uB3C4 \uB3D9\uC77C\uD55C \uACB0\uC81C \uC815\uBCF4 (\uC608 : \uC8FC\uBB38 ID, IP \uC8FC\uC18C, \uCD1D \uAE08\uC561 \uB4F1) \uC911 \uC77C\uBD80\uB97C \uC790\uCCB4\uC801\uC73C\uB85C \uCC98\uB9AC\uD558\uACE0 \uC77C\uC815 \uAE30\uAC04 \uB3D9\uC548\uC774 \uC815\uBCF4\uB97C \uACC4\uC18D \uAE30\uB85D\uD558\uC5EC \uC11C\uBE44\uC2A4 \uC644\uB8CC\uB97C \uD655\uC778\uD558\uC2ED\uC2DC\uC624.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uD1B5\uC2E0 \uB370\uC774\uD130 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uC7A5\uCE58 \uC815\uBCF4 : \uADC0\uD558\uAC00 \uB2F9\uC0AC \uC6F9 \uC0AC\uC774\uD2B8\uB97C \uBC29\uBB38 \uD560 \uB54C \uB2F9\uC0AC\uB294 \uC571\uC5D0\uC11C \uC77C\uBD80 \uC7A5\uCE58 \uC815\uBCF4\uB3C4 \uC218\uC9D1\uD569\uB2C8\uB2E4. \uC774 \uC815\uBCF4\uB294 \uC790\uB3D9\uC73C\uB85C \uAE30\uB85D\uB418\uBA70 \uC7A5\uCE58 \uBAA8\uB378, \uC6B4\uC601 \uCCB4\uC81C \uBC84\uC804 \uBC0F \uC720\uC0AC\uD55C \uBE44 \uC2DD\uBCC4 \uC815\uBCF4\uAC00 \uD3EC\uD568\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB2F9\uC0AC\uB294\uC774 \uC815\uBCF4\uB97C \uC0AC\uC6A9\uD558\uC5EC \uB2F9\uC0AC \uC11C\uBE44\uC2A4 \uC0AC\uC6A9\uC744 \uBAA8\uB2C8\uD130\uB9C1, \uAC1C\uBC1C \uBC0F \uBD84\uC11D \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. ',
                        _react2["default"].createElement('br', null),
                        '\uC7A5\uCE58 \uC2DD\uBCC4\uC790 : \uACBD\uC6B0\uC5D0 \uB530\uB77C \uB9C8\uCF00\uD305 \uB610\uB294 \uBD84\uC11D \uBAA9\uC801\uC73C\uB85C \uADC0\uD558\uC758 \uBAA8\uBC14\uC77C \uC7A5\uCE58 \uC2DD\uBCC4\uC790\uB97C \uAE30\uB85D \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. ',
                        _react2["default"].createElement('br', null),
                        '\uC774\uBA54\uC77C \uC8FC\uC18C : \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uC790 \uC774\uB984\uC73C\uB85C \uC0AC\uC6A9\uD558\uB294 \uACBD\uC6B0 \uB2F9\uC0AC\uB294\uC774\uB97C \uC0AC\uC6A9\uD558\uC5EC \uADC0\uD558\uC758 \uBA64\uBC84\uC2ED \uAD8C\uD55C\uC744 \uC2DD\uBCC4\uD569\uB2C8\uB2E4. ',
                        _react2["default"].createElement('br', null),
                        '\uD1B5\uC2E0 \uCD5C\uC801\uD654 \uB370\uC774\uD130 : \uC6B0\uB9AC\uB294 \uB124\uD2B8\uC6CC\uD06C \uC11C\uBE44\uC2A4\uB97C \uCD5C\uC801\uD654\uD558\uB294 \uB370 \uB3C4\uC6C0\uC774\uB418\uB294 \uB2E4\uC591\uD55C \uB3C4\uAD6C\uB97C \uC0AC\uC6A9\uD569\uB2C8\uB2E4. \uC0AC\uC6A9\uC790 \uC7A5\uCE58\uC758 \uC6B4\uC601 \uCCB4\uC81C (\uC608 : Windows, Mac, iOS, Android) \uC815\uBCF4 \uBC0F IP \uC8FC\uC18C\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uC6F9 \uC0AC\uC774\uD2B8\uC5D0\uC11C \uC218\uC9D1 \uB41C \uC815\uBCF4 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uC561\uC138\uC2A4 \uB85C\uADF8 : \uC778\uD130\uB137\uC5D0\uC788\uB294 \uB300\uBD80\uBD84\uC758 \uC6F9 \uC0AC\uC774\uD2B8\uC640 \uB9C8\uCC2C\uAC00\uC9C0\uB85C, Google \uC11C\uBE44\uC2A4 \uC720\uD615\uC744 \uC2E4\uD589\uD558\uAE30 \uC704\uD574 \uC561\uC138\uC2A4 \uB85C\uADF8 (IP \uC8FC\uC18C, \uBE0C\uB77C\uC6B0\uC800 \uC720\uD615, \uC6B4\uC601 \uCCB4\uC81C \uB4F1)\uB97C \uC790\uB3D9\uC73C\uB85C \uC218\uC9D1\uD569\uB2C8\uB2E4. \uC774 \uC815\uBCF4\uB294 \uB610\uD55C DDoS \uACF5\uACA9, \uC2A4\uCE94 \uBC0F \uC720\uC0AC\uD55C \uD574\uD0B9 \uACF5\uACA9\uC73C\uB85C\uBD80\uD130 \uBC29\uC5B4\uD558\uB294 \uB370 \uD544\uC218\uC801\uC785\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uAC1C\uC778 \uB370\uC774\uD130 \uACF5\uC720 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uBCF8 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45\uC5D0 \uBA85\uC2DC\uB418\uC9C0 \uC54A\uB294 \uD55C \uB2F9\uC0AC\uB294 \uADC0\uD558\uC758 \uAC1C\uC778 \uC815\uBCF4\uB97C \uC81C 3 \uC790\uC640 \uACF5\uC720\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uB370\uC774\uD130 \uBCF4\uC548 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uC6B0\uB9AC\uB294 \uB370\uC774\uD130 \uBCF4\uC548\uC744 \uB9E4\uC6B0 \uC911\uC694\uD558\uAC8C \uC0DD\uAC01\uD558\uBA70 \uADC0\uD558\uC758 \uB370\uC774\uD130\uB97C \uBCF4\uD638\uD558\uAE30 \uC704\uD574 \uD569\uB9AC\uC801\uC774\uACE0 \uD544\uC694\uD55C \uBAA8\uB4E0 \uC870\uCE58 (\uAE30\uC220, \uBB3C\uB9AC\uC801 \uB610\uB294 \uAD00\uB9AC)\uB97C \uCDE8\uD569\uB2C8\uB2E4. \uADF8\uB7EC\uB098 \uC5B4\uB5A4 \uD68C\uC0AC\uB3C4 \uC778\uD130\uB137 \uD1B5\uC2E0\uC758 \uC808\uB300\uC801\uC778 \uBCF4\uC548\uC744 \uBCF4\uC7A5 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC774 \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD568\uC73C\uB85C\uC368 \uADC0\uD558\uB294\uC774 \uC11C\uBE44\uC2A4\uB97C \uD1B5\uD574 \uADC0\uD558\uC5D0\uAC8C \uC81C\uACF5\uB41C \uC808\uB300\uC801\uC778 \uB370\uC774\uD130 \uBCF4\uC548\uC744 \uBCF4\uC7A5 \uD560 \uC218 \uC5C6\uC74C\uC744 \uBD84\uBA85\uD788 \uC778\uC815\uD569\uB2C8\uB2E4.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uD0C0\uC0AC SDK \uC0AC\uC6A9'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uD50C\uB7AB\uD3FC\uC758 \uC548\uC815\uC801\uC774\uACE0 \uC548\uC804\uD55C \uC791\uB3D9\uC744 \uBCF4\uC7A5\uD558\uAE30 \uC704\uD574 Umeng+SDK\uB97C \uC0AC\uC6A9\uD569\uB2C8\uB2E4. \uADC0\uD558\uAC00 \uC2B9\uC778\uD558\uACE0 \uB3D9\uC758\uD558\uBA74 \uB85C\uCEEC \uC7A5\uCE58 \uC815\uBCF4, MAC \uC8FC\uC18C \uBC0F \uC8FC\uD30C\uC218\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC5BB\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uC11C\uBE44\uC2A4 \uAE30\uB2A5 \uC0AC\uC6A9 \uAD8C\uD55C. \uAD8C\uD55C\uC744 \uBD80\uC5EC\uD558\uC9C0 \uC54A\uC73C\uBA74 \uC11C\uBE44\uC2A4\uC758 \uBCF4\uC548\uC5D0 \uC601\uD5A5\uC744 \uBBF8\uCE60 \uC218 \uC788\uC73C\uBA70 \uACE0\uD488\uC9C8 \uC0AC\uC6A9\uC790 \uACBD\uD5D8\uC744 \uC5BB\uC9C0 \uBABB\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. https://www.umeng.com/policy \uB97C \uBC29\uBB38\uD558\uC5EC \uC774\uD574\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. [Umeng+] \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' \uBB38\uC758\uD558\uAE30 '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\uBCF8 \uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45\uC5D0 \uB300\uD574 \uC9C8\uBB38\uC774\uB098 \uC6B0\uB824 \uC0AC\uD56D\uC774 \uC788\uB294 \uACBD\uC6B0 service@xiaoweiyunfu.com\uC73C\uB85C \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uC8FC\uC2ED\uC2DC\uC624.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' ',
                        this.state.companyName,
                        ' '
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        ' '
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    ' \uC9C0\uC6D0 '
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    ' \uC758\uACAC\uC774\uB098 \uC81C\uC548\uC774 \uC788\uC73C\uC2DC\uBA74 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uC8FC\uC2ED\uC2DC\uC624. ',
                                    _react2["default"].createElement(
                                        'br',
                                        null,
                                        ' '
                                    ),
                                    ' service@xiaoweiyunfu.com'
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'left' })
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023 ',
                            this.state.companyEnName,
                            '  \xA0\xA0 ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicyen' },
                                'Privacy Policy'
                            ),
                            ' '
                        )
                    )
                )
            );
        }
    }]);

    return PrivacyPolicyEn;
}(_react2["default"].Component);

exports["default"] = PrivacyPolicyEn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PrivacyPolicyKo.js
// module id = 387
// module chunks = 0